export const KPIBadge = ({
    value,
    percent,
    showPopover,
    type = "success",
    ...props
}: {
    value: any;
    percent: any;
    showPopover: any;
    type?: any;
    [key: string]: any;
}) => {
    const colors = {
        excellent: {
            value: '#d97706',
            bg: '#fef3c7',
            text: '#b45309'
        },
        success: {
            value: '#16a34a',
            bg: '#dcfce7',
            text: '#15803d'
        },
        warning: {
            value: '#ea580c',
            bg: '#ffedd5',
            text: '#c2410c'
        },
        danger: {
            value: '#dc2626',
            bg: '#fee2e2',
            text: '#b91c1c'
        }
    };

    const color = colors[type];
    const content = (
        <div
            {...props}
            style={{
                textAlign: 'center'
            }}
        >
            {percent ? <div
                style={{
                    fontWeight: 700,
                    fontSize: '15px',
                    color: color.value,
                    cursor: 'pointer'
                }}
            >
                {value}
            </div> : <span
                style={{
                    display: 'inline-block',
                    background: '#fef2f2',
                    color: color.value,
                    borderRadius: '12px',
                    padding: '2px 10px',
                    fontWeight: 600,
                    fontSize: '13px',
                    cursor: 'pointer'
                }}
            >
                {value}
            </span>}
            {percent && (
                <span
                    style={{
                        display: 'block', // xuống dòng
                        marginTop: '4px',
                        background: color.bg,
                        color: color.text,
                        padding: '2px 8px',
                        borderRadius: '999px',
                        fontSize: '11px',
                        fontWeight: 600,
                        width: 'fit-content',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                >
                    {percent}
                </span>
            )}
        </div>
    );

    if (showPopover) {
        return content;
    }
    return (
        <td
            style={{
                border: '1px solid #e5e7eb',
                padding: '10px',
                textAlign: 'center'
            }}
        >
            <div style={{ textAlign: 'center' }}>
                <div
                    style={{
                        fontWeight: 700,
                        fontSize: '15px',
                        color: color.value
                    }}
                >
                    {value}
                </div>
                {percent &&
                    < span
                        style={{
                            background: color.bg,
                            color: color.text,
                            padding: '2px 8px',
                            borderRadius: '999px',
                            fontSize: '11px',
                            fontWeight: 600
                        }}
                    >
                        {percent}
                    </span>}
            </div>
        </td>
    );
};